import React, { useState } from 'react'
import PaymentPlanCard from './PaymentPlanCard';
import Show from 'Components/Show/Show';
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';
import api from 'http';
import Skeleton from 'Components/skeleton/Skeleton';
import { toast } from 'react-toastify';
import { LuChevronDown, LuChevronUp } from 'react-icons/lu';

const PaymentPlans = ({ allPlans = [], loader = false, handleLoadMore, totalrecord, handleReload, handleEditPlan }) => {
  const [showAllPlans, setShowAllPlans] = useState(false);
  const [actionLoader, setActionLoader] = useState(false)

  const handleMakePayment = async (paymentPlanId) => {
    try {
      setActionLoader(true);
      await api.get(`${process.env.REACT_APP_TC_PMS}/api/PatientPaymentPlan/PayScheduledInstallmentManually?paymentPlanId=${paymentPlanId}`);
      if (handleReload) {
        handleReload();
      }
    } catch (error) {
      ErrorHandlingMessage(error)
    } finally {
      setActionLoader(false);
    }
  }


  const handleChangePayment = async (status, planId) => {
    const plan = allPlans.find((plan) => plan.id === +planId);
    try {
      setActionLoader(true);
      const payload = {
        "paymentPlanId": +planId,
        "subscriptionId": plan.subscriptionId,
        "stripeSettingId": plan.stripeSettingId,
        "newRecurringAmount": '',
        "updateRequestType": status,
        "newFinalPaymentDate": null
      }
      const resp = await api.post(`${process.env.REACT_APP_TC_PMS}/api/PatientPaymentPlan/UpdatePatientPaymentPlan`, payload);
      toast.success(resp.data.responseMessage);
      if (handleReload) {
        handleReload();
      }
    } catch (error) {
      ErrorHandlingMessage(error)
    } finally {
      setActionLoader(false);
    }
  }


  const handleToggleShowAll = () => {
    setShowAllPlans(!showAllPlans);
  };

  const balancePlans = allPlans.filter(plan => plan.planType === 'BAL');
  const displayedPaymentPlans = showAllPlans ? balancePlans : balancePlans.slice(0, 3);
  const hasMorePaymentPlans = balancePlans.length > 3;
  const hasMoreToLoad = allPlans.length === totalrecord && totalrecord >= 10;

  return (
    <div className="mb-4 bg-white  ">
        <Show when={!loader && !actionLoader} fallback={<Skeleton extraClass="w-full h-[160px]" />}>
          <div className="space-y-6">
            <Show when={displayedPaymentPlans.length > 0} fallback={<div className="p-4 text-center text-gray-500 border border-gray-200 rounded-lg bg-gray-50">No payment plans found.</div>}>
              {displayedPaymentPlans.map((plan) => (
                <PaymentPlanCard
                  key={plan.id}
                  plan={plan}
                  onMakePayment={handleMakePayment}
                  onEditPlan={handleEditPlan}
                  handleChangePayment={handleChangePayment}
                />
              ))}
            </Show>
          </div>
        </Show>
        <Show when={hasMorePaymentPlans}>
          <div className="mt-6 text-center">
            <button 
              onClick={handleToggleShowAll} 
              className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 transition-colors bg-white border  hover:bg-gray-50 focus:outline-none"
            >
              <Show when={showAllPlans} fallback={
                <>
                  View More ({balancePlans.length - 3} more)
                  <LuChevronDown className="w-4 h-4 ml-2" />
                </>
              }>
                <>
                  View Less
                  <LuChevronUp className="w-4 h-4 ml-2" />
                </>
              </Show>
            </button>
          </div>
        </Show>
        <Show when={hasMoreToLoad && balancePlans.length >= totalrecord}>
          <div className="mt-6 text-center">
            <button 
              onClick={handleLoadMore} 
              disabled={loader}
              className="inline-flex items-center px-4 py-2 text-sm font-medium text-white transition-colors bg-primary border border-primary rounded-lg hover:bg-primary-dark focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <Show when={loader} fallback="Load More (10 more records)">
                Loading...
              </Show>
            </button>
          </div>
        </Show>
    </div>
  )
}

export default PaymentPlans

